import { render, staticRenderFns } from "./weezys.vue?vue&type=template&id=151fc87f&scoped=true"
import script from "./weezys.vue?vue&type=script&lang=js"
export * from "./weezys.vue?vue&type=script&lang=js"
import style0 from "./weezys.vue?vue&type=style&index=0&id=151fc87f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151fc87f",
  null
  
)

export default component.exports